import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetTareaList } from '../../../reducers/tareaSlice';
import moment from 'moment';

function Tareas(props) {
    const logguedUserData = useSelector(state => state.common.logguedUserData);
    const tareaList = useSelector(state => state.tarea.tareaList);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchGetTareaList({ conjunto_id: logguedUserData.conjunto_id, order: 'id desc' }));
    }, []);

    const renderTarea = (tarea) => {
        const diferencia = tarea.fecha_ultima ? moment(tarea.fecha_ultima).add(tarea.dias_proximo || 0, 'd').diff(moment(), 'days') : 0;

        return (
            <li className="d-flex mb-4 pb-1" key={`dashboard_tarea_${tarea.id}`}>
                <div className="avatar flex-shrink-0 me-3">
                    <span className={`avatar-initial rounded bg-label-${diferencia <= tarea.dias_alerta ? 'danger' : 'succes'}`}><i className="bx bx-wrench"></i></span>
                </div>
                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                    <div className="me-2">
                        <h6 className="mb-0">{tarea.nombre}</h6>
                        <small className="text-muted">Fecha vencimiento: {tarea.fecha_ultima}</small>
                    </div>
                    <div className="user-progress">
                        <small className="fw-semibold">{diferencia} días</small>
                    </div>
                </div>
            </li>
        )
    }

    return (
        <div className="card list-inline-item">
            <div className="card-body ">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex flex-column align-items-center gap-1">
                        <h3 className="mb-2">TAREAS</h3>
                        <span>{tareaList?.reduce((p, c) => {
                            const diferencia = c.fecha_ultima ? moment(c.fecha_ultima).add(c.dias_proximo || 0, 'd').diff(moment(), 'days') : 0;

                            if (c.fecha_ultima && diferencia <= c.dias_alerta)
                                return p + 1;
                            return p;
                        }, 0)} Urgentes</span>
                    </div>
                    <div ></div>
                </div>
                <ul className="p-0 m-0">
                    {
                        tareaList?.map(tl => (
                            renderTarea(tl)
                        ))
                    }
                </ul>
            </div>
        </div>
    );
}

export default Tareas;